/**
 * @fileoverview
 * Guest Guard - Prevents authenticated users from accessing auth pages (login, forgot-password, etc.)
 * Redirects authenticated users to dashboard
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services';

export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If user is authenticated, redirect to dashboard
  if (authService.isAuthenticated()) {
    return router.createUrlTree(['/dashboard']);
  }

  // If not authenticated, allow access to auth pages
  return true;
};

